export function camelize(text: string) {
  return text.replace(/^([A-Z])|[\s-_]+(\w)/g, function (_, p1, p2) {
    if (p2) return p2.toUpperCase();
    return p1.toLowerCase();
  });
}

export function slugify(text: string): string {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text
}

export function stripTags(text: string): string {
  return text.replace(/(<([^>]+)>)/gi, '');
}

export function debounce(func: Function, timeout: number) {
  let timer: number;
  return (...args: any) => {
    clearTimeout(timer);
    timer = window.setTimeout(() => {
      func(...args);
    }, timeout);
  };
}

export const getOnChangeValue = (
  eventOrValue:
    | React.SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>
    | string
) => {
  const value: string =
    typeof eventOrValue === 'string'
      ? (eventOrValue as string)
      : eventOrValue.currentTarget.value;
  return value;
};
